// extracted by mini-css-extract-plugin
module.exports = {"homeBottomPanelHeight":"500px","topBarHeight":"60px"};